import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { Input, Checkbox, Segment, Button, Icon, Form, Divider, Dropdown, Popup } from 'semantic-ui-react';
import { createResponse, editResponse, getResponse } from 'modules/surveys';
import Detail from './Detail';
import ListResponses from './List';
import NewResponse from './NewResponse';


const sortingOptions=[
    {key: 'Most Recent', text: 'Most Recent', value: 'create_date'},
    {key: 'Project Title', text: 'Project Title', value: 'project_title'}
]

class SidebarContent extends React.Component {
    constructor(props) {
        super(props);
        this.handleNewResponseClick = this.handleNewResponseClick.bind(this);
        this.exitForm = this.exitForm.bind(this);
        this.handleResponseSelect = this.handleResponseSelect.bind(this);
        this.handleResponseBack = this.handleResponseBack.bind(this);
        this.handleEditResponse = this.handleEditResponse.bind(this);
        this.handleMyResponsesToggle = this.handleMyResponsesToggle.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleResponseDelete = this.handleResponseDelete.bind(this);
        this.state = {
            addnewproj: false,
            selectedResponse: null,
            map: null,
            showMyResponses: false,
            sortBy: sortingOptions[0].value,
            searchFor: ""
        };
    }

    handleNewResponseClick() {
        if (this.state.selectedResponse) {
            getResponse(this.state.selectedResponse.id)
        }
        this.setState({ addnewproj: !this.state.addnewproj});
    }

    exitForm() {
        if (this.state.selectedResponse) {
            getResponse(this.state.selectedResponse.id)
        }
        this.props.map.drawControl._toolbars.draw._modes.marker.handler.disable()
        this.props.map.drawControl._toolbars.draw._modes.polygon.handler.disable()
        this.setState({addnewproj: false});
    }

    handleResponseDelete() {
        this.props.map.drawControl._toolbars.draw._modes.marker.handler.disable()
        this.props.map.drawControl._toolbars.draw._modes.polygon.handler.disable()
        this.setState({addnewproj: false, selectedResponse: null});
    }

    handleResponseSelect(selectResponse) {
        this.setState({selectedResponse: selectResponse});
    }

    handleEditResponse(selectResponse) {
        this.setState({
            selectedResponse: selectResponse,
            addnewproj: true
        });
    }

    handleResponseBack() {
        this.setState({selectedResponse: null});
        this.props.map.flyTo([28.459033019728043, -81.3427734375]).setZoom(7)
    }

    handleMyResponsesToggle() {
        this.setState({showMyResponses: !this.state.showMyResponses})
    }

    handleSortChange(e, { value }) {
        this.setState({sortBy: value})
    }

    handleSearchChange(e, {value}) {
        this.setState({searchFor: value})
    }

    //componentWillUnmount() {
    //    this.props.map.drawLayer.clearLayers();
    //    console.log('clearing layers', this.state.map.drawLayer.clearLayers())
    //}

    render() {
        if (this.state.addnewproj) {

            return (
                <NewResponse
                    data={this.props.detail.metaFields}
                    surveyID={this.props.detail.id}
                    onCancel={this.exitForm}
                    onDelete={this.handleResponseDelete}
                    onSubmit={this.exitForm}
                    createResponse={createResponse}
                    onSelect={this.handleResponseSelect}
                    getResponse={getResponse}
                    responseFields={(this.state.selectedResponse === null) ? {} : this.state.selectedResponse.field_data}
                    responseID={(this.state.selectedResponse === null) ? null : this.state.selectedResponse.id}
                    editResponse={editResponse}
                    onBack={this.handleResponseBack}
                    map={this.props.map}
                    geometries={(this.state.selectedResponse === null) ? null : this.state.selectedResponse.geometries}
                />
            );
        } else if (this.state.selectedResponse !== null) {
            return (
                <Detail
                    getResponse={getResponse}
                    response={this.state.selectedResponse}
                    onBack={this.handleResponseBack}
                    onEdit={this.handleEditResponse}
                    map={this.props.map}
                    survey={this.props.detail.metaFields}
                />
            );
        }
        return (
            <div style={{height: '100%' }}>
                <Segment style={{height: '100%' }}>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Input
                                    icon="search"
                                    iconPosition="left"
                                    placeholder="Search conservation actions"
                                    value={this.state.searchFor}
                                    onChange={this.handleSearchChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field>
                                { (this.props.userId != null) ? <Checkbox
                                    floated="left"
                                    label={{children: 'My Conservation Actions'}}
                                    checked={this.state.showMyResponses}
                                    onChange={this.handleMyResponsesToggle}
                                /> : null }
                            </Form.Field>
                            <Form.Field>
                                {gettext('Sort by')}:&nbsp;
                                <Dropdown
                                    inline
                                    options={sortingOptions}
                                    value={this.state.sortBy}
                                    onChange={this.handleSortChange}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                    <ListResponses
                        onSelect={this.handleResponseSelect}
                        map={this.props.map}
                        showMyResponses={this.state.showMyResponses}
                        owner={this.props.userId}
                        sortBy={this.state.sortBy}
                        searchFor={this.state.searchFor}
                    />
                    <div className="sidebarFooter">
                        <Divider style={{marginTop: "0px"}}/>
                        {this.props.userId ?
                            <Button
                                color="blue"
                                onClick={this.handleNewResponseClick}
                            >
                                <Icon name="plus"/>
                                {gettext('Conservation Action')}
                            </Button>
                            :
                            <Popup
                                content="You need to sign in to create a Conservation Action"
                                trigger={
                                    <div>
                                        <Button
                                            disabled
                                            color="blue"
                                            onClick={this.handleNewResponseClick}
                                        >
                                            <Icon name="plus"/>
                                            {gettext('Conservation Action')}
                                        </Button>
                                    </div>
                                }
                            />
                        }

                    </div>
                </Segment>
            </div>
        );
    }
}

SidebarContent.propTypes = {
    map: PropTypes.instanceOf(L.Map),
    detail: PropTypes.shape({
        id: PropTypes.string,
        slug: PropTypes.string,
        metaFields: PropTypes.arrayOf(PropTypes.object)
    }),
    list: PropTypes.arrayOf(PropTypes.object),
    userId: PropTypes.string
};

SidebarContent.defaultProps = {
    map: null,
    detail: {},
    list: [],
    userId: null
};

const mapStateToProps = state => ({userId: state.getIn(['people', 'userId'])});

export default connect(mapStateToProps)(SidebarContent);



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/index.jsx